import React, { Component } from "react";
import logo from "../icons8-movie-64.png";
import {Link} from "react-router-dom"
export default class navBar extends Component {
  

  render() {
    return (
      <div
        className="border
        flex items-center
        space-x-8
        md:pl-12 
        pl-2
        py-4
        
      "
      >
        <img src={logo}
          className="w-[50px]"
          alt="img"
        />
        <Link to="/" className="font-bold text-xl text-blue-400" 
        >Movies</Link>
        <Link to="/fav" className="font-bold text-xl text-blue-400">Favourites</Link>
      </div>
    );
  }
}
